import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const PortfolioAgeDeletedPage = lazy(() => import('./PortfolioAgeDeletedPage'));

const path = 'reports/age/delete';
const PortfolioAgeDeletedRoute: FuseRouteItemType = {
	path: path,
	element: <PortfolioAgeDeletedPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Deleted Domain Age',
					helpName: 'Age Delete',
					showTitle: false,
					showCrumbs: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default PortfolioAgeDeletedRoute;
